import { getForm } from '@api/formsApi';
import { useQuery } from 'api-hooks/hooks';
import { DateView } from '@components';
import Box from '@components/box/Box';
import Loading from '@components/loading/Loading';
import { Col, Row } from 'antd';
import React from 'react';
import './CustomizationDetails.less';
import CustomizationDetailsEdit from './CustomizationDetailsEdit';
import CustomizationDetailsView from './CustomizationDetailsReadonly';

type Props = {
  formId: number;
  customerId: number;
  edit?: boolean;
  editable?: boolean;
  onBack?: () => any;
  onEdit?: () => any;
  onSave?: () => any;
};

const CustomizationDetails: React.FC<Props> = ({
  customerId,
  formId,
  editable = true,
  edit = false,
  onBack = () => {},
  onEdit = () => {},
  onSave = () => {},
}) => {
  const result = useQuery(getForm(formId, customerId));

  const handleSave = () => {
    result.refetch();
    onSave();
  };

  edit = editable ? edit : false;

  return (
    <Loading {...result} minHeight={300}>
      {(form) => (
        <Box
          header={
            <Row type="flex" align="middle">
              <Col span={18}>
                Customization:&nbsp;
                <span className="text-secondary">{form.name}</span>
              </Col>
              <Col span={6} className="CustomizationDetails-header">
                last update:&nbsp;
                <strong>
                  <DateView date={form.modified_at} />
                </strong>
              </Col>
            </Row>
          }
          content={
            <div className="CustomizationDetails-content">
              {edit ? (
                <CustomizationDetailsEdit
                  formModel={form}
                  onSave={handleSave}
                  onBack={onBack}
                  customerId={customerId}
                />
              ) : (
                <CustomizationDetailsView
                  editable={editable}
                  form={form}
                  onEdit={onEdit}
                  onBack={onBack}
                  customerId={customerId}
                />
              )}
            </div>
          }
        />
      )}
    </Loading>
  );
};

export default CustomizationDetails;
